<template>
  <div class="hello wrapper">
    <div class="box-horizontal" style="position:fixed; top: 0;right: 0;left: 0;bottom: 0;">
      <div class="ml20 mr20">
        <h2 class="block">Selamat Datang</h2>
        <div class="coba f15">Ini adalah halaman pembayaran Internet Anda. </div>
        <div class="coba f15 mb20"><strong class="red">PASTIKAN KONFIRMASI</strong> ke Internet provider anda apakah pakai aplikasi ini.</div>

        <button class="btn btn-info w100 mb10" @click="dash.login()">Gas Login!!</button>

        <!-- <img src="http://localhost/qr/saved/1.png" alt="qr code" class="w100" /> -->
      </div>
    </div>
  </div>
</template>

<script>
/*

        <div class="block text-center mb10">
          <span>atau</span>
        </div>
        <button class="btn btn-yellow w100 mb10 hitam" @click="dash.nologin()">Tanpa Login</button>
        
*/
import Vue from 'vue'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/MyGlobal'
import router from '@/router'

export default {
  setup() {
    const dash = {
      data: reactive({
          this: ''
      }),
      login() {
        router.push({ 
            name: 'login'
        });
      },
      nologin() {
        router.push({ 
            name: 'nologin'
        });
      }
    }

    return {
      myGlobal,
      dash
    }
  },
  mounted () {
    document.title = "My Wifi";
  }
  /*
  methods: {
    printTicketod: function() {
      try {
        // eslint-disable-next-line no-undef
        if (printerx) {
          // eslint-disable-next-line no-undef
          printerx.printTicketod('Hello Tod');
        }
      } catch (error) {
        //reject(error);
      }
    }
  }
  */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue